import { render, staticRenderFns } from "./AuthorizationsStepsCreatePage.vue?vue&type=template&id=e6f035de&scoped=true&"
import script from "./AuthorizationsStepsCreatePage.vue?vue&type=script&lang=js&"
export * from "./AuthorizationsStepsCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationsStepsCreatePage.vue?vue&type=style&index=0&id=e6f035de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f035de",
  null
  
)

export default component.exports